<nz-modal [nzTitle]="modalTitle" [nzVisible]="isVisible" (nzOnOk)="onSubmit()" (nzOnCancel)="handleCancel()"
    [nzOkLoading]="heaaderLoader | async">
    <ng-template #modalTitle>
        <h3>Atualizar Cabeçalho</h3>
    </ng-template>
    <ng-container *nzModalContent>
        <form nz-form [formGroup]="headerForm" [nzLayout]="'vertical'" nz-col nzSm="24">
            <nz-form-item nz-col>
                <nz-form-label> Chassis</nz-form-label>
                <nz-form-control>
                    <input type="text" nz-input placeholder="digite o Chassis" formControlName="chassis" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item nz-col>
                <nz-form-label> Horimetro</nz-form-label>
                <nz-form-control>
                    <input type="number" nz-input placeholder="digite o Horimetro" formControlName="hours_meter" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item nz-col>
                <nz-form-label> Observação</nz-form-label>
                <nz-form-control>
                    <textarea nz-input placeholder="digite a observação"
                        formControlName="maintenance_observation"></textarea>
                </nz-form-control>
            </nz-form-item>
            @if(checklistType === 'auction') {
            <nz-form-item nz-col>
                <nz-form-label> Nome do Cliente</nz-form-label>
                <nz-form-control>
                    <input type="text" nz-input placeholder="digite o nome do cliente" formControlName="client_name" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item nz-col>
                <nz-form-label> Email do Cliente</nz-form-label>
                <nz-form-control>
                    <input type="email" nz-input placeholder="digite o email do cliente"
                        formControlName="client_email" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item nz-col>
                <nz-form-label> Telefone do Cliente</nz-form-label>
                <nz-form-control>
                    <input type="tel" nz-input placeholder="digite o telefone do cliente"
                        formControlName="client_phone" />
                </nz-form-control>
            </nz-form-item>
            }
        </form>
    </ng-container>
    <ng-container *nzModalFooter>
        <button nz-button (click)="onSubmit()" type="button" nzType="primary">
            <label>Atualizar Cabeçalho</label>
        </button>
    </ng-container>
</nz-modal>